import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { getMe, logoutRequest } from "../lib/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = authed

  const checkSession = useCallback(async () => {
    try {
      const me = await getMe();
      setUser(me);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  // Called after a successful magic-link verify (cookie is already set by the server).
  const login = useCallback(async () => {
    setUser(null);
    await checkSession();
  }, [checkSession]);

  const logout = useCallback(async () => {
    try {
      await logoutRequest();
    } catch (e) {
      console.error("Logout request failed; clearing local session anyway.", e);
    }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, logout }), [user, login, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
